/**
 * Константы для страницы прокси
 */

// Размеры страницы для пагинации
export const PAGE_SIZE_OPTIONS = ['10', '15', '20', '50', '100'];
export const DEFAULT_PAGE_SIZE = 15;

// Начальные значения пагинации
export const INITIAL_PAGINATION = {
  current: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  total: 0,
  showSizeChanger: true,
  showQuickJumper: true,
  showTotal: (total, range) => `${range[0]}-${range[1]} из ${total} прокси`,
  pageSizeOptions: PAGE_SIZE_OPTIONS,
  size: 'default'
};

// Цвета для типов прокси
export const PROXY_TYPE_COLORS = {
  'http': 'blue',
  'socks4': 'green',
  'socks5': 'orange'
};

// Опции для фильтра доступности
export const AVAILABILITY_FILTER_OPTIONS = [
  { text: 'Доступен', value: 'доступен' },
  { text: 'Недоступен', value: 'недоступен' },
  { text: 'Нет данных', value: 'none' }
];

// Опции для фильтра статуса
export const STATUS_FILTER_OPTIONS = [
  { text: 'Активен', value: true },
  { text: 'Неактивен', value: false }
];

// Опции для фильтра автозамены
export const AUTO_REPLACE_FILTER_OPTIONS = [
  { text: 'Включена', value: true },
  { text: 'Выключена', value: false }
];

// Опции для типа прокси
export const PROXY_TYPE_OPTIONS = [
  { text: 'HTTP', value: 'http' },
  { text: 'SOCKS4', value: 'socks4' },
  { text: 'SOCKS5', value: 'socks5' }
];

const PROXIES_CONSTANTS = {
  PAGE_SIZE_OPTIONS,
  DEFAULT_PAGE_SIZE,
  INITIAL_PAGINATION,
  PROXY_TYPE_COLORS,
  AVAILABILITY_FILTER_OPTIONS,
  STATUS_FILTER_OPTIONS,
  AUTO_REPLACE_FILTER_OPTIONS,
  PROXY_TYPE_OPTIONS
};

export default PROXIES_CONSTANTS;































